import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import normalizeInternalLink from 'commons/normalizeInternalLink';
import IconArrowRightSimple from 'components/icons/iconArrowRightSimple';
import ProductImage from './ProductImage';

const ShopPageListItem = ({ title, link, product }) => (
  <li className="[border-bottom:1px_solid_#f1f1f1] list-none m-0 px-0 py-[5px] max-[767px]:pl-6 max-[767px]:pr-6 last:[border-bottom:0]">
    <Link
      to={normalizeInternalLink(link)}
      className="block max-[767px]:flex max-[767px]:flex-row max-[767px]:justify-between max-[767px]:items-center hover:!no-underline"
    >
      <div className="flex flex-row items-center">
        <div className="items-center flex h-[38px] mr-7 transition-[all_.25s_ease-in-out] w-[38px]">
          <ProductImage {...product} forceFallback layout="thumbnail" />
        </div>

        <div className="text-[#4a4a4a]">{title} </div>
      </div>
      <IconArrowRightSimple className="md:hidden" />
    </Link>
  </li>
);

ShopPageListItem.propTypes = {
  title: PropTypes.string,
  link: PropTypes.string,
  product: PropTypes.object,
};

export default ShopPageListItem;
